// extracted by mini-css-extract-plugin
export var alertIcon = "_ru-0";